// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* gray11*/
.graphWrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  -webkit-user-select: none;
          user-select: none;
}

.graphToolbar {
  flex: 0 1;
}

.graphSvg {
  width: 100%;
  min-height: 600px;
  flex-grow: 1;
}

.node:hover rect,
.node:hover polygon {
  filter: url("#brightness");
}
.node text {
  fill: #333;
  font-size: 13px;
  pointer-events: none;
}
.node rect,
.node circle,
.node polygon {
  stroke: #333;
  fill: #fff;
  stroke-width: 0.6px;
}
.node rect {
  rx: 5px;
  ry: 5px;
}
.node.type-SUB_WORKFLOW rect {
  stroke-width: 5px;
}
.node.type-TERMINAL circle {
  stroke: #333;
  fill: #eee;
  stroke-width: 0.6px;
}
.node.type-TERMINAL text {
  color: #333;
  font-weight: bold;
}
.node.type-TERMINAL.dimmed circle {
  stroke: #c8c8c8;
}
.node.dimmed.bar rect {
  stroke: #c8c8c8 !important;
  fill: #c8c8c8;
}
.node.dimmed text {
  fill: #c8c8c8;
}
.node.dimmed rect,
.node.dimmed polygon,
.node.dimmed circle {
  fill: #fff;
  stroke: #c8c8c8;
}
.node.status_COMPLETED.bar rect {
  stroke: #163e1d !important;
  fill: #163e1d;
}
.node.status_COMPLETED text {
  fill: #163e1d;
}
.node.status_COMPLETED rect,
.node.status_COMPLETED polygon,
.node.status_COMPLETED circle {
  fill: #aee1b8;
  stroke: #163e1d;
}
.node.status_COMPLETED_WITH_ERRORS.bar rect {
  stroke: #8b5b02 !important;
  fill: #8b5b02;
}
.node.status_COMPLETED_WITH_ERRORS text {
  fill: #8b5b02;
}
.node.status_COMPLETED_WITH_ERRORS rect,
.node.status_COMPLETED_WITH_ERRORS polygon,
.node.status_COMPLETED_WITH_ERRORS circle {
  fill: #feeac5;
  stroke: #8b5b02;
}
.node.status_IN_PROGRESS.bar rect {
  stroke: #c2920d !important;
  fill: #c2920d;
}
.node.status_IN_PROGRESS text {
  fill: #c2920d;
}
.node.status_IN_PROGRESS rect,
.node.status_IN_PROGRESS polygon,
.node.status_IN_PROGRESS circle {
  fill: #fff5da;
  stroke: #c2920d;
}
.node.status_SCHEDULED.bar rect {
  stroke: #11497a !important;
  fill: #11497a;
}
.node.status_SCHEDULED text {
  fill: #11497a;
}
.node.status_SCHEDULED rect,
.node.status_SCHEDULED polygon,
.node.status_SCHEDULED circle {
  fill: #cbe2f7;
  stroke: #11497a;
}
.node.status_CANCELED.bar rect {
  stroke: #26194b !important;
  fill: #26194b;
}
.node.status_CANCELED text {
  fill: #26194b;
}
.node.status_CANCELED rect,
.node.status_CANCELED polygon,
.node.status_CANCELED circle {
  fill: #ded5f8;
  stroke: #26194b;
}
.node.status_FAILED.bar rect, .node.status_FAILED_WITH_TERMINAL_ERROR.bar rect, .node.status_TIMED_OUT.bar rect, .node.status_DF_PARTIAL.bar rect {
  stroke: #7f050b !important;
  fill: #7f050b;
}
.node.status_FAILED text, .node.status_FAILED_WITH_TERMINAL_ERROR text, .node.status_TIMED_OUT text, .node.status_DF_PARTIAL text {
  fill: #7f050b;
}
.node.status_FAILED rect,
.node.status_FAILED polygon,
.node.status_FAILED circle, .node.status_FAILED_WITH_TERMINAL_ERROR rect,
.node.status_FAILED_WITH_TERMINAL_ERROR polygon,
.node.status_FAILED_WITH_TERMINAL_ERROR circle, .node.status_TIMED_OUT rect,
.node.status_TIMED_OUT polygon,
.node.status_TIMED_OUT circle, .node.status_DF_PARTIAL rect,
.node.status_DF_PARTIAL polygon,
.node.status_DF_PARTIAL circle {
  fill: #f9c6c9;
  stroke: #7f050b;
}
.node.status_SKIPPED.bar rect {
  stroke: gray !important;
  fill: gray;
}
.node.status_SKIPPED text {
  fill: gray;
}
.node.status_SKIPPED rect,
.node.status_SKIPPED polygon,
.node.status_SKIPPED circle {
  fill: #fff;
  stroke: gray;
}
.node.selected {
  filter: url("#dropShadow");
}

.node.bar {
  /*
    &.type-EXCLUSIVE_JOIN {
      rect {
        stroke: \$dark-color;
        fill: #fff;
        stroke-width: \$outline-width;
      }
      rect.underline {
        stroke-width: 0;
        fill: \$dark-color;
      }
      text {
        fill: \$dark-color;
      }
      &.dimmed {
        rect {
          stroke: \$light-color;
          fill: #fff;        
        }
        text {
          fill: \$light-color;
        }
      }
    }
  */
}
.node.bar.type-FORK_JOIN_DYNAMIC rect {
  stroke: #333;
  stroke-width: 5;
  stroke-dasharray: 10;
}
.node.bar.type-FORK_JOIN_DYNAMIC.dimmed rect {
  stroke: #c8c8c8;
}
.node.bar rect {
  rx: 0px;
  ry: 0px;
  stroke-width: 0;
  fill: #333;
}
.node.bar text {
  fill: #fff;
}
.node.bar.dimmed rect {
  fill: #c8c8c8;
}

.edgePath path {
  marker-end: url(#endarrow);
  stroke: #333;
  stroke-width: 1px;
}
.edgePath.reverse path {
  marker-end: none;
  marker-start: url(#startarrow);
}
.edgePath.dimmed path {
  stroke: #c8c8c8;
  stroke-dasharray: 5;
  marker-end: url(#endarrow-dimmed);
}
.edgePath.dimmed marker {
  fill: #c8c8c8;
}
.edgePath.dimmed.reverse path {
  marker-end: none;
  marker-start: url(#startarrow-dimmed);
}
.edgePath.executed path {
  stroke-width: 2px;
}

.edgeLabel {
  fill: blue;
  font-size: 12px;
}
.edgeLabel.dimmed text {
  fill: #c8c8c8;
}`, "",{"version":3,"sources":["webpack://./src/components/diagram/diagram.scss"],"names":[],"mappings":"AACuB,UAAA;AAMvB;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,yBAAA;UAAA,iBAAA;AALF;;AAQA;EACE,SAAA;AALF;;AAQA;EACE,WAAA;EACA,iBAAA;EACA,YAAA;AALF;;AA4BI;;EAEE,0BAAA;AAzBN;AA6BE;EACE,UAnDS;EAoDT,eAAA;EACA,oBAAA;AA3BJ;AA8BE;;;EAGE,YA3DS;EA4DT,UA1DI;EA2DJ,mBAzDY;AA6BhB;AA+BE;EACE,OAAA;EACA,OAAA;AA7BJ;AAiCI;EACE,iBAAA;AA/BN;AAmCI;EACE,YA5EO;EA6EP,UAAA;EACA,mBAAA;AAjCN;AAmCI;EACE,WAjFO;EAkFP,iBAAA;AAjCN;AAmCI;EACE,eApFQ;AAmDd;AA1BI;EACE,0BAAA;EACA,aA3BQ;AAuDd;AAzBE;EACE,aA/BU;AA0Dd;AAzBE;;;EAGE,UAbiC;EAcjC,eArCU;AAgEd;AAvCI;EACE,0BAAA;EACA,aAiEiB;AAxBvB;AAtCE;EACE,aA6DmB;AArBvB;AAtCE;;;EAGE,aAwD4B;EAvD5B,eAuDmB;AAfvB;AApDI;EACE,0BAAA;EACA,aAoEiB;AAdvB;AAnDE;EACE,aAgEmB;AAXvB;AAnDE;;;EAGE,aA2D4B;EA1D5B,eA0DmB;AALvB;AAjEI;EACE,0BAAA;EACA,aAuEiB;AAJvB;AAhEE;EACE,aAmEmB;AADvB;AAhEE;;;EAGE,aA8D4B;EA7D5B,eA6DmB;AAKvB;AA9EI;EACE,0BAAA;EACA,aA0EiB;AAMvB;AA7EE;EACE,aAsEmB;AASvB;AA7EE;;;EAGE,aAiE4B;EAhE5B,eAgEmB;AAevB;AA3FI;EACE,0BAAA;EACA,aA6EiB;AAgBvB;AA1FE;EACE,aAyEmB;AAmBvB;AA1FE;;;EAGE,aAoE4B;EAnE5B,eAmEmB;AAyBvB;AAxGI;EACE,0BAAA;EACA,aAmFiB;AAuBvB;AAvGE;EACE,aA+EmB;AA0BvB;AAvGE;;;;;;;;;EAGE,aA0E4B;EAzE5B,eAyEmB;AAsCvB;AA3HI;EACE,uBAAA;EACA,UAsFiB;AAuCvB;AA1HE;EACE,UAkFmB;AA0CvB;AA1HE;;;EAGE,UAbiC;EAcjC,YA4EmB;AAgDvB;AA9CE;EACE,0BAAA;AAgDJ;;AA5CA;EAaE;;;;;;;;;;;;;;;;;;;;;;;;GAAA;AA2DF;AAtEI;EACE,YA5HO;EA6HP,eAAA;EACA,oBAAA;AAwEN;AArEM;EACE,eAjIM;AAwMd;AA1CE;EACE,OAAA;EACA,OAAA;EACA,eAAA;EACA,UAnKS;AA+Mb;AA1CE;EACE,UApKI;AAgNR;AAxCI;EACE,aA1KQ;AAoNd;;AApCE;EACE,0BAAA;EACA,YAnLS;EAoLT,iBAAA;AAuCJ;AAnCI;EACE,gBAAA;EACA,8BAAA;AAqCN;AAhCI;EACE,eA/LQ;EAgMR,mBAAA;EACA,iCAAA;AAkCN;AAhCI;EACE,aApMQ;AAsOd;AA7BI;EACE,gBAAA;EACA,qCAAA;AA+BN;AA1BI;EACE,iBAAA;AA4BN;;AAxBA;EACE,UApNiB;EAqNjB,eAAA;AA2BF;AA1BE;EACE,aAzNU;AAqPd","sourcesContent":["$dark-color: #333;\n$light-color: #c8c8c8; /* gray11*/\n$white: #fff;\n$edge-label-color: blue;\n$outline-width: 0.6px;\n$node-text-size: 12px;\n\n.graphWrapper {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  user-select: none;\n}\n\n.graphToolbar {\n  flex: 0;\n}\n\n.graphSvg {\n  width: 100%;\n  min-height: 600px;\n  flex-grow: 1;\n}\n\n@mixin nodeColor($colorfg, $colorbg: #fff) {\n  &.bar {\n    rect {\n      stroke: $colorfg !important;\n      fill: $colorfg;\n    }\n  }\n  text {\n    fill: $colorfg;\n  }\n  rect,\n  polygon,\n  circle {\n    fill: $colorbg;\n    stroke: $colorfg;\n  }\n}\n\n.node {\n  &:hover {\n    rect,\n    polygon {\n      filter: url(\"#brightness\");\n    }\n  }\n\n  text {\n    fill: $dark-color;\n    font-size: 13px;\n    pointer-events: none;\n  }\n\n  rect,\n  circle,\n  polygon {\n    stroke: $dark-color;\n    fill: $white;\n    stroke-width: $outline-width;\n  }\n\n  rect {\n    rx: 5px;\n    ry: 5px;\n  }\n\n  &.type-SUB_WORKFLOW {\n    rect {\n      stroke-width: 5px;\n    }\n  }\n  &.type-TERMINAL {\n    circle {\n      stroke: $dark-color;\n      fill: #eee;\n      stroke-width: 0.6px;\n    }\n    text {\n      color: $dark-color;\n      font-weight: bold;\n    }\n    &.dimmed circle {\n      stroke: $light-color;\n    }\n  }\n\n  &.dimmed {\n    @include nodeColor($light-color);\n  }\n  &.status_COMPLETED {\n    @include nodeColor(#163e1d, #aee1b8);\n  }\n  &.status_COMPLETED_WITH_ERRORS {\n    @include nodeColor(#8b5b02, #feeac5);\n  }\n  &.status_IN_PROGRESS {\n    @include nodeColor(#c2920d, #fff5da);\n  }\n  &.status_SCHEDULED {\n    @include nodeColor(#11497a, #cbe2f7);\n  }\n  &.status_CANCELED {\n    @include nodeColor(#26194b, #ded5f8);\n  }\n  &.status_FAILED,\n  &.status_FAILED_WITH_TERMINAL_ERROR,\n  &.status_TIMED_OUT,\n  &.status_DF_PARTIAL {\n    @include nodeColor(#7f050b, #f9c6c9);\n  }\n  &.status_SKIPPED {\n    @include nodeColor(gray);\n  }\n  &.selected {\n    filter: url(\"#dropShadow\");\n  }\n}\n\n.node.bar {\n  &.type-FORK_JOIN_DYNAMIC {\n    rect {\n      stroke: $dark-color;\n      stroke-width: 5;\n      stroke-dasharray: 10;\n    }\n    &.dimmed {\n      rect {\n        stroke: $light-color;\n      }\n    }\n  }\n  /*\n  &.type-EXCLUSIVE_JOIN {\n    rect {\n      stroke: $dark-color;\n      fill: #fff;\n      stroke-width: $outline-width;\n    }\n    rect.underline {\n      stroke-width: 0;\n      fill: $dark-color;\n    }\n    text {\n      fill: $dark-color;\n    }\n    &.dimmed {\n      rect {\n        stroke: $light-color;\n        fill: #fff;        \n      }\n      text {\n        fill: $light-color;\n      }\n    }\n  }\n*/\n  rect {\n    rx: 0px;\n    ry: 0px;\n    stroke-width: 0;\n    fill: $dark-color;\n  }\n  text {\n    fill: $white;\n  }\n\n  &.dimmed {\n    rect {\n      fill: $light-color;\n    }\n  }\n}\n\n.edgePath {\n  path {\n    marker-end: url(#endarrow);\n    stroke: $dark-color;\n    stroke-width: 1px;\n  }\n\n  &.reverse {\n    path {\n      marker-end: none;\n      marker-start: url(#startarrow);\n    }\n  }\n\n  &.dimmed {\n    path {\n      stroke: $light-color;\n      stroke-dasharray: 5;\n      marker-end: url(#endarrow-dimmed);\n    }\n    marker {\n      fill: $light-color;\n    }\n  }\n\n  &.dimmed.reverse {\n    path {\n      marker-end: none;\n      marker-start: url(#startarrow-dimmed);\n    }\n  }\n\n  &.executed {\n    path {\n      stroke-width: 2px;\n    }\n  }\n}\n.edgeLabel {\n  fill: $edge-label-color;\n  font-size: 12px;\n  &.dimmed text {\n    fill: $light-color;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
